import React from 'react'
import {
    CRow,
} from '@coreui/react'
import { useRouteMatch } from "react-router-dom";
import history from '../../../../history'


const CanadianProvincialRedirect = ({match}) => {

    return (
        <CRow>
        </CRow>
    )
  }
  
  export default CanadianProvincialRedirect;